import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
import { faqs } from "../../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-177" data-mp="2z3h2k9lv7bjl">
      <div className="mx-auto max-w-3xl" data-id="element-178" data-mp="3msjjff8od0d1">
        <SectionHeading kicker="Frequently asked questions" title="Everything you need to know before purchasing" data-id="element-179" data-mp="3mtl3283rav6d" />

        <div className="mt-10 space-y-3" data-id="element-180" data-mp="3rtqp98r9bph2">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-181" data-mp="3i1b7abfyn0w6" data-mpi={i}>
                <h3 data-id="element-182" data-mp="9lrhjmei00lv">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 rounded-2xl p-5 text-left text-base font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-electric sm:text-lg" data-id="element-183" data-mp="9l88ywaqmoki">
                    <span data-id="element-184" data-mp="2aict7yzi3e62">{f.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-electric transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-185" data-mp="25pjk6yx01jo6" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-186" data-mp="2tf44pm8swozk">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-187" data-mp="2td1fv5jdx1wf">
                      <div className="space-y-2 px-5 pb-5 text-base text-muted" data-id="element-188" data-mp="1jsrx94o6x406">
                        {f.a.map(p => <p key={p} data-id="element-189" data-mp="1sqkggjx18vsu">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <TransformCTA headline="All your questions answered? Get started now" label="Get Instant Access" data-id="element-190" data-mp="22ortiro7atpk" />
      </div>
    </section>;
}